// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 3V2H22V22H13V15H11V22H2V2H4V3H8V2H10V10H14V2H16V3H20ZM8 5H4V20H6V10H8V5ZM16 10H18V20H20V5H16V10Z"}}]};

const Castle3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle-3-filled',
    ref,
    icon: element,
  },
));

Castle3FilledIcon.displayName = 'Castle3FilledIcon';

export default Castle3FilledIcon;
